import React from "react";
import Pagination from "./Pagination";
import QueryField, { IProps as IQueryFieldProps } from "../QueryField";

export type TProps<TQueryName extends string> = Omit<
    React.ComponentProps<typeof Pagination>,
    "currentPage" | "onPageChange"
> &
    Pick<IQueryFieldProps<TQueryName, string>, "query">;

const FALLBACK_PAGE = 1;

const QueryPagination = <T extends string>({ query, ...props }: TProps<T>) => {
    return (
        <QueryField query={query}>
            {({ value, setValue }) => {
                let pageNumber = value ? +value : FALLBACK_PAGE;

                if (!Number.isInteger(pageNumber)) {
                    pageNumber = FALLBACK_PAGE;
                }

                return (
                    <Pagination
                        currentPage={pageNumber}
                        onPageChange={page => setValue(page.toString(10))}
                        {...props}
                    />
                );
            }}
        </QueryField>
    );
};

export default QueryPagination;
